var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"cadastro-container"}},[_c('Header'),_c('div',{staticStyle:{"margin-bottom":"48px"}},[_c('cadastrosimples',{on:{"cadastropesquisa":_vm.retorno_cadastro}})],1),_c('footersite',{staticClass:"d-none d-xl-block"}),_c('footersitemobile',{staticClass:"d-block d-xl-none"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }